import { render, staticRenderFns } from "./QuickAddButton.vue?vue&type=template&id=72cae1c8&scoped=true&"
import script from "./QuickAddButton.vue?vue&type=script&lang=js&"
export * from "./QuickAddButton.vue?vue&type=script&lang=js&"
import style0 from "./QuickAddButton.vue?vue&type=style&index=0&id=72cae1c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cae1c8",
  null
  
)

export default component.exports